// Mobile 専用:backend AI insight の targetModule → /mobile/* ルート helper。
//
// PC の resolveTargetRoute(targetModule) は /mail-v2 /analytics などの PC ルートを返す。
// Mobile は別ルート体系(全部 /mobile/*)なので、AI action のリンクをここで変換する。
//
// 設計決定(2026-09-16, Mobile Dashboard Daily Companion 化):
// - 既存の PC resolveTargetRoute は変更しない(PC ユーザー影響ゼロ)
// - mobile のみ targetModule → /mobile/<module> に変換
// - mobile に存在しない module(例: chatbot / settings)は fallback で /mobile/dashboard へ
//   → ボタン自体は出さず、"PC で確認" 表示に切替可能(将来)

const MOBILE_TARGET_ROUTE_MAP: Record<string, string> = {
  mail: "/mobile/mail",
  analytics: "/mobile/analytics",
  site: "/mobile/site",
  blog: "/mobile/blog",
  "ai-blog": "/mobile/ai-blog",
  instagram: "/mobile/instagram",
  "google-business": "/mobile/google-business",
  chatbot: "/mobile/chatbot",
  dashboard: "/mobile/dashboard",
  settings: "/mobile/dashboard", // mobile に settings 入口あり、だが AI 推薦からは dashboard へ
};

export function resolveMobileTargetRoute(targetModule: string | null | undefined): string {
  if (!targetModule) return "/mobile/dashboard";
  return MOBILE_TARGET_ROUTE_MAP[targetModule] ?? "/mobile/dashboard";
}

export function hasMobileTargetRoute(targetModule: string | null | undefined): boolean {
  if (!targetModule) return false;
  return targetModule in MOBILE_TARGET_ROUTE_MAP;
}
